import { ENABLE_BUTTON, DISABLE_BUTTON } from './types';

export const enableButton = () => async (dispatch) => {
    dispatch({ type: ENABLE_BUTTON});

  }
  
export const disableButton = () => async (dispatch) => {
    dispatch({ type: DISABLE_BUTTON});

  }